import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

export type IConfigSlice = {
  contact: boolean;
};
const initialState: IConfigSlice = {
  contact: false
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    TOGGLE_CONTACT_FORM: (state, action: PayloadAction<boolean>) => ({
      ...state,
      contact: action.payload
    })
  }
});

export const { TOGGLE_CONTACT_FORM } = configSlice.actions;

export const GET_APP_CONFIG = (state: RootState) => state.app.config;
